export * from './useTipoConsumoService'
